// src/lib/serviceWorker.ts — registering public/sw.js.
//
// Registered after `load` so the worker's install, and its shell fetches, do
// not compete with the first render for the same connection.
//
// Skipped entirely in dev: a service worker in front of Vite's dev server
// serves yesterday's modules and makes HMR look broken in ways that are very
// hard to attribute.

export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // An unregistrable worker costs offline support and the install prompt,
      // and nothing else. Not worth interrupting anyone over.
    });
  });
}
